import { string, null as zNull } from "zod/v4";

export const conciergePresent = {
  name: "conciergePresent" as const,
  input: string(),
  output: zNull(),
};
